import { render } from "./NoticeList.vue?vue&type=template&id=29f6da8e&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"

import "./NoticeList.vue?vue&type=style&index=0&id=29f6da8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f6da8e"]])

export default __exports__